import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useDelFundsMutation, useListFundsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Funds',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default: undefined
    },
    columns: {
      type: Array,
      default: function _default() {
        return ['name'];
      }
    },
    defaultFilters: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showDelete: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    height: {
      type: String,
      default: function _default() {
        return 'calc(100vh - 200px)';
      }
    }
  },
  emits: ['input', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var currentIds = computed(function () {
      return (props.modelValue !== undefined ? props.modelValue : props.value) || [];
    });
    var headers = computed(function () {
      return [{
        value: 'id',
        sortable: true
      }, {
        value: 'name'
      }, {
        value: 'portfolio.name'
      }, {
        value: 'volume'
      }, {
        value: 'fundStrategy'
      }, {
        value: 'actions'
      }].filter(function (o) {
        return props.columns && props.columns.includes(o.value);
      }).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          sortable: col.sortable || false
        });
      }) || [];
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var filters = ref({
      taxonomyIds: [],
      text: ''
    });
    var search = ref('');
    var variables = computed(function () {
      return {
        keyword: search.value,
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListFundsQuery = useListFundsQuery(variables),
      result = _useListFundsQuery.result,
      refetch = _useListFundsQuery.refetch,
      loading = _useListFundsQuery.loading;
    var items = computed(function () {
      var _result$value$listFun, _result$value;
      return (_result$value$listFun = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listFunds) !== null && _result$value$listFun !== void 0 ? _result$value$listFun : [];
    });
    var _useDelFundsMutation = useDelFundsMutation(),
      delFunds = _useDelFundsMutation.mutate,
      onDone = _useDelFundsMutation.onDone;
    onDone(function () {
      refetch();
      dialog.value = false;
      confirm.value = '';
    });
    var itemCount = computed(function () {
      var _result$value2;
      return ((_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countFunds) || 0;
    });
    var confirm = ref('');
    var dialog = ref(false);
    var selectedIds = ref([]);
    var selectedItemsForDelete = computed(function () {
      var list = items.value;
      var ids = selectedIds.value;
      if (!Array.isArray(list)) return [];
      if (!Array.isArray(ids)) return [];
      return list.filter(function (item) {
        return item && item.id != null && ids.includes(item.id);
      });
    });
    var onInput = function onInput(v) {
      selectedIds.value = v;
      emit('update:modelValue', v);
      emit('input', v);
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      currentIds: currentIds,
      headers: headers,
      options: options,
      filters: filters,
      search: search,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      items: items,
      delFunds: delFunds,
      onDone: onDone,
      itemCount: itemCount,
      confirm: confirm,
      dialog: dialog,
      selectedIds: selectedIds,
      selectedItemsForDelete: selectedItemsForDelete,
      onInput: onInput
    };
  }
});